<template>
  <div class="pt-4 pb-3 mt-5">
    <div class="h3 text-capitalize mb-0 text-start">
      {{ translateApiLabel(item.title) }}
    </div>
  </div>
</template>

<script>
import translateApiLabelMixin from "@/own/mixins/translateApiLabelMixin";

export default {
  name: "DashboardLabelNew",
  mixins: [translateApiLabelMixin],
  props: ["item"],
};
</script>
